export const mapperToOptions = (
    options,
    id = 'id',
    name = 'name',
    picture = 'picture',
    occupation = 'occupation',
    manager_id = 'manager_id'
) => {
    return options.map((option) => {
        return {
            value: option[id],
            label: option[name],
            picture: option[picture],
            occupation: option[occupation],
            manager_id: option[manager_id],
        }
    })
}
